import {
  Modal,
  ModalBody,
  ModalHeader
} from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { setIsNeedInvoiceModalOpen } from '@/modules/perseo-billing/store/slices/billing';

import { NeedInvoiceForm } from './form';

export const NeedInvoiceModal = () => {
  const billing = useAppSelector((state) => state.billing);
  const { isNeedInvoiceModalOpen } = billing || {};

  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(setIsNeedInvoiceModalOpen(false));
  };

  return (
    <div className="co-z-40">
      <Modal size="md" isOpen={isNeedInvoiceModalOpen} onClose={closeModal}>
        <ModalHeader
          icon={{
            name: 'content',
            fill: 'primary-500'
          }}
          title="Datos de facturación"
          onClose={closeModal}
        />
        <ModalBody>
          <div className="co-flex co-flex-col co-h-full co-w-full">
            <NeedInvoiceForm />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
